export function downloadExcelFile(base64Data, // Base64 string of the file
fileName // Name of the file to download
) {
    // Decode base64 and create a Blob
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map(function (_, i) { return byteCharacters.charCodeAt(i); });
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // Create a download link
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
